<template>
    <div>

        <div id="hello-hello">
            <p style="display:inline;float: left;line-height: 22px;"><b>缺勤申请列表</b></p>
        </div>

        <el-table :data="absenceList" style="width: 100%" highlight-current-row>
            <el-table-column prop="applicationType" label="申请类型" min-width="10%">
            </el-table-column>

            <el-table-column prop="startTime" label="起始（补卡）时间" min-width="20%">
            </el-table-column>

            <el-table-column prop="endTime" label="结束时间" min-width="20%">
            </el-table-column>

            <el-table-column prop="employeeName" label="申请人" min-width="10%">
            </el-table-column>
            <el-table-column prop="createdTime" label="申请时间" min-width="20%">
            </el-table-column>
            <el-table-column prop="remark" label="说明" min-width="20%">
            </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div>
            <el-pagination background :page-size="pageNum" :page-count="pageCount" layout="total, sizes, prev, pager, next"
                :total="total" @current-change="pageClick" :page-sizes="[8, 12, 16, 20]" @size-change="handleSizeChange">
            </el-pagination>
        </div>

    </div>
</template>

<script>
export default {
    name: "ChkWork",
    data() {
        return {
            token: this.getToken(),
            companyId: this.getCompanyId(),
            imagePath: this.getImagePath(),
            userId: this.getUserId(),

            absenceList: [],
            
            form: {
                id: '',
                customer: '',

                productList: [],
                productId: '',
                productName: '',

                status: 0,
                remark: '',
                inspectionPicOne:''
            },

            loading: false,
            formLabelWidth: '120px',

            inspectionItemList: [],

            pageIndex: 0,
            pageNum: 8,
            total: 0,
            pageCount: 0
        }
    },
    methods: {
        getAll() {

            this.$axios({
                method: "post",
                url: "/shiro/abs/apply/getAll",
                data: {
                    userId:this.userId,
                    companyId: this.companyId
                },
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" })
                }

                if (data.status === 202) {
                    this.$notify({
                        title: '重要提示',
                        message: data.msg,
                        duration: 0
                    })
                    return
                }

                if (data.status != 200) {
                    this.$message({
                        type: 'info',
                        message: data.msg
                    })
                    return
                }

                this.absenceList = data.data
                this.total = this.absenceList[0].total
                for (let i in this.absenceList) {
                    this.absenceList[i].applicationType=this.absenceList[i].applicationType==0?'补卡':'请假'

                    this.absenceList[i].startTime = this.$moment(this.absenceList[i].startTime).format("YYYY-MM-DD HH:mm")
                    this.absenceList[i].endTime = this.$moment(this.absenceList[i].endTime).format("YYYY-MM-DD HH:mm")
                    this.absenceList[i].createdTime = this.$moment(this.absenceList[i].createdTime).format("YYYY-MM-DD HH:mm")
                }
            })
        },
        pageClick(currentPage) {
            this.absenceList = []

            this.pageIndex = (currentPage - 1) * this.pageNum
            this.getAll()
        },
        handleSizeChange(val) {
            this.pageNum = val

            this.getAll()
        },
    },
    mounted() {
        this.getAll()
    }
}
</script>

<style>
#create_work {
    position: relative;
    right: 5px;
    width: 120px;
}

.DisabledSelection .el-checkbox__inner {
    display: none;
    position: relative;
}

.el-pagination__total {
    color: green;
}
</style>